var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIconGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb-icon--green-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Pro-14\"-Copy",
    transform: "translate(-1125, -514)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb-icon--green-2",
    transform: "translate(1125, 514)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#EDEDED",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "fb-icon--brown.fbda7af8775c2a3196af2caac36e1d4d",
    transform: "translate(16, 10)",
    fill: "#82BD02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6393014,28 L10.6393014,13.9983607 L15.3727199,13.9983607 L16,9.17331822 L10.6393014,9.17331822 L10.6473434,6.75833801 C10.6473434,5.49989271 10.7937759,4.82558889 13.0073509,4.82558889 L15.9664915,4.82558889 L15.9664915,0 L11.2324029,0 C5.54600104,0 3.544535,2.3406647 3.544535,6.27692669 L3.544535,9.17386468 L0,9.17386468 L0,13.9989071 L3.544535,13.9989071 L3.544535,28 L10.6393014,28 Z",
    id: "Shape-Copy-15"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIconGreen2);
export default __webpack_public_path__ + "static/media/fb-icon--green-2.faadc853ef1d758c4accfeb7c73b332e.svg";
export { ForwardRef as ReactComponent };